export default [
    {
        path: "redeem-voucher-code",
        name: "RedeemVoucherCode",
        meta:{
            permissionPath: 'redemption.redeem_voucher',
        },
        component: () =>
            import(
                /* webpackChunkName: "redeemVoucherCode" */ "@/views/storePanel/redeem/tabs/RedeemVoucherCode.vue"
            )
    },

    {
        path: "coupons-overview",
        name: "CouponsOverview",
        meta:{
            permissionPath: 'redemption.coupons_overview',
        },
        component: () =>
            import(
                /* webpackChunkName: "couponsOverview" */ "@/views/storePanel/redeem/tabs/CouponsOverview.vue"
            )
    },

    {
        path: "multiple-coupons",
        name: "MultipleCoupons",
        meta:{
            permissionPath: 'redemption.multiple_coupons',
        },
        component: () =>
            import(
                /* webpackChunkName: "multipleCoupons" */ "@/views/storePanel/redeem/tabs/MultipleCoupons.vue"
            )
    }
];
